<template>
  <div class="pc-age-and-sex">
    <!-- <div id="age" style="height: 400px; width: 50%"></div> -->
    <div id="sex" style="height: 400px; width: 100%"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ageData: {
        under18: 0,
        under22: 0,
        under25: 0,
        under30: 0,
        under35: 0,
        under40: 0,
        over40: 0,
      },
      genderData:{

      },
      label: {
        show: true,
        formatter: [
          "{a|{b} }", //引导线上面文字
          "{b|}", //引导线下面文字
        ].join("\n"), //用\n来换行
        // fontSize: "14",
        // fontWeight: "300",
        color: "#434343",
        position: "outside",
        //a和b来识别不同的文字区域
        rich: {
          a: {
            left: 50,
            top: -10,
            padding: [10, -10, -30, -10],
            fontWeight: "300",
            fontSize: "14",
          },
          b: {
            height: 5,
            width: 5,
            lineHeight: 5,
            marginBottom: 10,
            padding: [0, -5],
            borderRadius: 5,
            borderWidth: 1,
            borderColor: "#4E97D6",
          },
        },
      },
      labelLine: {
        showAbove: true,
        show: true,
        smooth: 0.1,
        length: 15,
        length2: 25,
        maxSurfaceAngle: 90,
        lineStyle: {
          color: "#4E97D6",
        },
      },
    };
  },
  watch: {
    userData: function (newVal, oldVal) {
      console.log(this.userData);
      this.genderData = this.userData.gender_result
      for (let key in this.userData.age) {
        if (key <= 18 && key != 0) {
          this.ageData.under18 += this.userData.age[key];
        }
        if (key <= 22 && key > 18) {
          this.ageData.under22 += this.userData.age[key];
        }
        if (key <= 25 && key > 22) {
          this.ageData.under25 += this.userData.age[key];
        }
        if (key <= 30 && key > 25) {
          this.ageData.under30 += this.userData.age[key];
        }
         if (key <= 35 && key > 30) {
          this.ageData.under35 += this.userData.age[key];
        }
         if (key <= 40 && key > 35) {
          this.ageData.under40 += this.userData.age[key];
        }
         if (key > 40 ) {
          this.ageData.over40 += this.userData.age[key];
        }
      }
      // this.createEchartsAge();
      this.createEchartsSex()
    },
  },
  props: ["userData"],

  methods: {
    createEchartsAge() {
      let that = this;
      var myChart = document.getElementById("age");
      var myChart = this.$echarts.init(myChart);
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} ({d}%)",
        },
        graphic: {
          type: "image",
          style: {
            image: require("../../../../../static/image/userManagement/age.png"),
            width: 70,
            height: 70,
          },
          left: "center",
          top: "165",
          tooltip: {
            show: false,
          },
        },
        tooltip: {
          backgroundColor: "rgba(50,50,50,0.9)",
          trigger: "item",
          //   formatter: "{b}用户: {c} ({d}%)",
          formatter: " {b}: {c}\n ({d}%)",
          borderColor: "transparent",
          borderWidth: "5",
          textStyle: {
            fontSize: "12",
            lineHeight: "12",
            height: "10",
            color: "white",
          },
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["25%", "60%"],
            center: ["50%", "50%"],
            // avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 5,
              borderColor: "#fff",
              borderWidth: 2,
            },
            emphasis: { focus: "data" },
            label: {
              show: true,
              formatter: "{d}%",
              fontSize: "10",
              fontWeight: "bold",
              color: "#434343",
              position: "outside",
              //a和b来识别不同的文字区域
              formatter: [
                "{a|{b} }", //引导线上面文字
                "{b|}", //引导线下面文字
              ].join("\n"), //用\n来换行
              rich: {
                a: {
                  left: 0,
                  padding: [-40, -60, -30, -30],
                },
                b: {
                  height: 5,
                  width: 5,
                  lineHeight: 5,
                  marginBottom: 10,
                  padding: [0, -5],
                  borderRadius: 5,
                  borderWidth: 1,
                  borderColor: "#4E97D6",
                },
              },
            },
            labelLine: {
              show: true,
              smooth: 0.1,
              length: 40,
              length2: 15,
              minTurnAngle: 30,
              lineStyle: {
                color: "#4E97D6",
              },
            },
            data: [
              {
                value: that.ageData.under18,
                name: "<18岁",
                itemStyle: { color: "#6ddcdb" },
              },
              {
                value: that.ageData.under22,
                name: "18-22岁",
                itemStyle: { color: "#6179CF" },
              },
              {
                value: that.ageData.under25,
                name: "22-25岁",
                itemStyle: { color: "#98d37d" },
              },
              {
                value: that.ageData.under30,
                name: "25-30岁",
                itemStyle: { color: "#f9d05c" },
              },
              {
                value: that.ageData.under35,
                name: "25-35岁",
                itemStyle: { color: "#F2746F" },
              },
              {
                value: that.ageData.under40,
                name: "35-40岁",
                itemStyle: { color: "#c14089" },
              },
              {
                value: that.ageData.over40,
                name: ">40岁",
                itemStyle: { color: "#7DC6E4" },
              },
            ],
          },
        ],
      };
      if (option && typeof option === "object") {
        myChart.setOption(option, true);
      }
    },
    createEchartsSex() {
      let that = this;
      var myChart = document.getElementById("sex");
      var myChart = this.$echarts.init(myChart);
      let option = {
        backgroundColor: "#fff",
        tooltip: {
          backgroundColor: "rgba(50,50,50,0.9)",
          trigger: "item",
          //   formatter: "{b}用户: {c} ({d}%)",
          formatter: " {b} :{c}\n ({d}%)",
          borderColor: "transparent",
          borderWidth: "5",
          textStyle: {
            fontSize: "12",
            lineHeight: "12",
            height: "10",
            color: "white",
          },
        },
        graphic: {
          type: "image",
          style: {
            image: require("../../../../../static/image/userManagement/sex.png"),
            width: 70,
            height: 70,
          },
          left: "center",
          top: "165",
          tooltip: {
            show: false,
          },
        },

        series: [
           {
            name: "女",
            type: "pie",
            radius: ["22%", "60%"],
            center: ["50%", "50%"],
            labelLine: {
              show: false,
            },
            zlevel: 1000,
            data: [
              {
                name: "男",
                tooltip: {
                  show: true,
                },
                value:
                that.genderData["1"],
                label: that.label,
                labelLine: that.labelLine,
                itemStyle: {
                  color: "#6989F8",
                },
              },
              {
                name: "女",
                value: that.genderData['2'],
                itemStyle: {
                  color: "#FDC130",
                },
                label: that.label,
                labelLine: that.labelLine,
                labelLayout: { rect: { x: 20, y: 200, width: 20, height: 20 } },
              },
            ],
          },
          // {
          //   name: "男",
          //   type: "pie",
          //   emphasis: {
          //     scale: 1,
          //   },
          //   radius: ["44%", "54%"],
          //   center: ["50%", "50%"],
          //   labelLine: {
          //     show: false,
          //   },

          //   data: [
          //     {
          //       name: "男",
          //       value: that.genderData['1'],
          //       itemStyle: {
          //         color: "#6989F8",
          //       },
          //       label: that.label,
          //       labelLine: that.labelLine,
          //     },
          //     {
          //       name: "其他",
          //       tooltip: {
          //         show: false,
          //       },
          //       value:
          //         that.genderData["0"],
          //       label: {
          //         show: true,
          //       },
          //       itemStyle: {
          //         color: "#EEEEEE",
          //       },
          //     },
          //   ],
          // },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>

<style scoped lang="scss">
.pc-age-and-sex {
  display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/groupPortrait/AgeAndSex.vue